import axios from 'axios';

export default async function (event) {
  if (!event.hasOwnProperty('service')) {
    event.service = 'ba-suppliers-front';
  }
  if (!event.hasOwnProperty('companyId')) {
    const supplierId = localStorage.getItem('supplierId');
    if (supplierId) {
      event.companyId = supplierId;
    }
  }
  await axios({
    method: 'POST',
    url: `${process.env.VUE_APP_API}/events/send`,
    data: event,
  }).catch((error) => {
    console.log('axios-error', error);
  });
}
